// tpmt is two power minus ten times t scaled to [0,1]
export function tpmt(x) {
  return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}
